import { render, staticRenderFns } from "./igt-sidebar-category.vue?vue&type=template&id=1323ddac&scoped=true&"
import script from "./igt-sidebar-category.vue?vue&type=script&lang=js&"
export * from "./igt-sidebar-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1323ddac",
  null
  
)

export default component.exports